import { Box, Typography, Avatar, Link } from '@mui/material';
import Logo from './../../icons/logo.svg';
import LeaveBoardButton from './LeaveBoardButton';
import { useAccount } from '../../contexts/Account';
import { getAdvisorQueryParams } from '../../utils/queryParams';

const Footer = ({ company }) => {
  const displayYear = new Date().getFullYear();
  const { accountDetails, isFreeTrial, isFreemium } = useAccount();

  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        mt: 3,
        mb: 1,
      }}
    >
      <Box
        sx={{
          mx: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          px: 2,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 0.5,
            flexDirection: { xxs: 'column', xs: 'row' },
          }}
        >
          <Avatar
            alt={`${company.companyName} Logo`}
            src={Logo}
            sx={{
              width: { xxs: 50, xs: 32 },
              height: { xxs: 50, xs: 32 },
              mt: '-4px',
            }}
          />
          <Typography
            sx={{
              fontWeight: '500',
              fontSize: '14px',
              lineHeight: '22px',
              color: '#001030',
            }}
          >
            {company.companyName} Advisory Board, Built on AdvisoryCloud
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 0.5,
            flexDirection: { xxs: 'column', xs: 'row' },
          }}
        >
          <Link
            href={`https://register.advisorycloud.com/babs/add-your-advisory-board/?${getAdvisorQueryParams(
              {
                accountDetails,
                isFreeTrial,
                isFreemium,
              }
            )}`}
            sx={{
              fontWeight: '500',
              fontSize: '14px',
              lineHeight: '22px',
              color: '#2C71F6',
              textDecoration: 'none',
              cursor: 'pointer',
              mb: '4px',
            }}
          >
            Start Your Own Advisory Board
          </Link>
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ display: { xxs: 'none', xs: 'block' } }}
          >
            |
          </Typography>
          <Link
            href={`https://register.advisorycloud.com/boardroom/referral/?${getAdvisorQueryParams(
              {
                accountDetails,
                isFreeTrial,
                isFreemium,
              }
            )}`}
            sx={{
              fontWeight: '500',
              fontSize: '14px',
              lineHeight: '22px',
              color: '#2C71F6',
              textDecoration: 'none',
              cursor: 'pointer',
              mb: '4px',
            }}
          >
            Refer a Colleague
          </Link>
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ display: { xxs: 'none', xs: 'block' } }}
          >
            |
          </Typography>
          <LeaveBoardButton company={company}></LeaveBoardButton>
        </Box>

        {/* Texto confidencial */}
        <Typography
          sx={{
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '22px',
            color: '#001030',
            mb: 0.5,
          }}
        >
          Confidential Board Member Information
        </Typography>

        <Typography
          sx={{
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '22px',
            color: '#001030',
          }}
        >
          Copyright © {displayYear}, All Rights Reserved
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
